module.exports = __webpack_public_path__ + "static/media/igedo.48627b3d.png";